import React, { Component } from 'react';

const icon = "menuUser"
const roles = ["View", "Add", "Edit", "Delete"]

class Users extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			time: new Date(),
			filterBy: {}, sortBy: 'email', sortOrder: 1,
			resetUserPIN: '',
			rolesToAdd: [],
			rolesToRemove: [],
			error: false
		};
	}

	cancel = () => {
		this.setState({ editing: false, deleting: false, changingStatus: false, resetting: false, unlocking: false, editingRoles: false, loading: false, error: false })
	}
	add = (e) => {
		this.setState({
			editing: {
				id: null, email: "", firstName: "", lastName: "", wholeName: "", password: "", failedAttempts: 0, roles: { "default": true }, queues: {}, loggedIn: false, oldPasswords: [], passwordUpdated: "", userID: "", accessCode: "", ActivityDateTime: "",
				status: ""
			}
		})
	}
	edit = (user) => (e) => {
		this.setState({ editing: user })
	}
	valueChange = (field) => (e) => {
		var editing = JSON.parse(JSON.stringify(this.state.editing))
		editing[field] = e.currentTarget.value
		this.setState({ editing: editing })
	}

	confirm = () => {
		if (this.state.editing.email.toString().length < 1 || !(/[^@]+@[^\.]+\..+/gm.test(this.state.editing.email))) {
			this.setState({ error: 'Please enter a valid email address.' });
		} else if (this.state.editing.firstName.toString().length < 1) {
			this.setState({ error: "Please enter the user's first name." });
		} else if (this.state.editing.lastName.toString().length < 1) {
			this.setState({ error: "Please enter the user's last name." });
		} else if (this.state.editing.userID && (this.state.editing.userID.toString().length < 4 || this.state.editing.userID.toString().length > 10)) {
			this.setState({ error: 'UserID must be between 4-10 digits.' });
		} else if (this.state.editing.accessCode && (this.state.editing.accessCode.toString().length < 4 || this.state.editing.accessCode.toString().length > 10)) {
			this.setState({ error: 'Access Code must be at between 4-10 digits.' });
		} else if (!this.state.editing.userID && this.state.editing.accessCode) {
			this.setState({ error: 'Enter a User ID, or remove Access Code.' });
		} else if (this.state.editing.userID && !this.state.editing.accessCode) {
			this.setState({ error: 'Enter an Access Code, or remove User ID.' });
		} else if (this.state.editing.userID && this.state.editing.accessCode && this.state.editing.userID == this.state.editing.accessCode) {
			this.setState({ error: 'User ID and Access Code must be different.' });
		} else {
			this.setState({ loading: true });
			if (this.state.editing.id) {
				this.props.ws.send(JSON.stringify({ route: 'editUser', user: this.state.editing }))
			} else {
				this.props.ws.send(JSON.stringify({ route: 'addUser', user: this.state.editing }))
			}
		}
	}

	unlockUser = (user) => (e) => {
		this.setState({ unlocking: user })
	}
	confirmUnlockUser = () => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'unlockUser', user: this.state.unlocking }))
	}

	changeStatus = (user) => (e) => {
		this.setState({ changingStatus: user })
	}
	confirmChangeStatus = (e) => {
		this.setState({ loading: true });
		var online = e.currentTarget.className === "onStatusOption"
		this.props.ws.send(JSON.stringify({ route: 'statusUpdate', user: this.state.changingStatus, status: e.currentTarget.innerHTML, online: online }))
	}
	confirmUserLogout = (e) => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'logOutUser', user: this.state.changingStatus }))
	}

	resetUser = (user) => (e) => {
		this.setState({ resetting: user, resetUserPIN: '' })
	}
	resetUserPINChange = (e) => {
		if (e.target.value.length < 1) {
			this.setState({ resetUserPIN: '', error: 'Enter a new password for this user.' });
		} else {
			this.setState({ resetUserPIN: e.target.value, error: '' });
		}
	}
	confirmResetUser = () => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'resetUser', user: this.state.resetting, resetUserPIN: this.state.resetUserPIN }))
	}

	changeRoles = (user) => (e) => {
		this.setState({ editingRoles: user, rolesToAdd: [], rolesToRemove: [] });
	}

	addRole = (role) => (e) => {
		var rolesToAdd = this.state.rolesToAdd.slice()
		var rolesToRemove = this.state.rolesToRemove.slice()
		rolesToAdd.push(role)
		if (rolesToRemove.indexOf(role) > -1) {
			rolesToRemove.splice(rolesToRemove.indexOf(role), 1)
		}
		this.setState({ rolesToAdd: rolesToAdd, rolesToRemove: rolesToRemove })
	}
	removeRole = (role) => (e) => {
		var rolesToAdd = this.state.rolesToAdd.slice()
		var rolesToRemove = this.state.rolesToRemove.slice()
		rolesToRemove.push(role)
		if (rolesToAdd.indexOf(role) > -1) {
			rolesToAdd.splice(rolesToAdd.indexOf(role), 1)
		}
		this.setState({ rolesToAdd: rolesToAdd, rolesToRemove: rolesToRemove })
	}
	confirmRoleChanges = () => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'updateUserRoles', user: this.state.editingRoles, rolesToAdd: this.state.rolesToAdd, rolesToRemove: this.state.rolesToRemove }))
	}


	deleteUser = (user) => (e) => {
		this.setState({ deleting: user })
	}
	confirmDeleteUser = () => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'deleteUser', user: this.state.deleting }))
	}

	componentWillReceiveProps(nextProps) {
		if (this.state.loading) {
			this.cancel()
		}
	}

	componentDidMount = () => {
		this.timerTick = setInterval(() => {
			if (this.props.active) {
				this.setState({ time: new Date() })
			}
		}, 1000);
	}

	sort = (sortBy) => (e) => {
		var sortOrder
		if (this.state.sortOrder === -1) {
			sortOrder = 1;
		} else {
			sortOrder = -1;
		}
		this.setState({ sortBy: sortBy, sortOrder: sortOrder })
	}

	filter = (field) => (e) => {
		var filterBy = this.state.filterBy
		if (e.target.value.length > 0) {
			filterBy[field] = e.target.value
		} else {
			delete filterBy[field]
		}
		this.setState({ filterBy: filterBy })
	}

	sortFunc(sortBy, sortOrder) {
		return function (a, b) {
			if (sortBy === "status" || sortBy === "ActivityDateTime") {
				if ('status' in a && 'status' in b) {
					if (!a.loggedIn && !b.loggedIn) {
						return a.username > b.username ? 1 * sortOrder : -1 * sortOrder
					} else if (!a.loggedIn) {
						return 1
					} else if (!b.loggedIn) {
						return -1
					}
					if (a[sortBy] === b[sortBy]) {
						return a.username > b.username ? 1 * sortOrder : -1 * sortOrder
					}
					return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
				} else {
					if ('status' in a) {
						return -1
					}
					return 1
				}
			}

			if (sortBy in a && sortBy in b) {
				if (a[sortBy] === b[sortBy]) {
					return a.email > b.email ? 1 * sortOrder : -1 * sortOrder
				}
				return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
			} else if (!(sortBy in a) && !(sortBy in b)) {
				return a.email > b.email ? 1 * sortOrder : -1 * sortOrder
			} else {
				return sortBy in a ? -1 : 1
			}
		}
	}

	filterFunc(array, filterBy) {
		return array.filter(function (object) {
			for (var prop in filterBy) {
				if (typeof object[prop] === "undefined") {
					return false
				}
				if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
					return false
				}
			}
			return true
		})
	}

	convertMS(ms) {
		var d, h, m, s;
		s = Math.floor(ms / 1000);
		m = Math.floor(s / 60);
		s = s % 60;
		h = Math.floor(m / 60);
		m = m % 60;
		d = Math.floor(h / 24);
		h = h % 24;

		var statusTime = ''

		d > 0 ? statusTime += d + ' days, ' : statusTime += ''
		h < 1 ? statusTime += '' : h > 0 && h < 10 ? statusTime += '0' + h + ':' : statusTime += h + ':'
		m < 1 ? statusTime += '00:' : m < 10 ? statusTime += '0' + m + ':' : statusTime += m + ':'
		s < 1 ? statusTime += '00' : s < 10 ? statusTime += '0' + s : statusTime += s

		return statusTime;
	};

	render() {
		if (this.props.active) {
			var users = [];

			for (var user in this.props.data.Users) {
				users.push(this.props.data.Users[user]);
			}

			//Filtering User List
			if (Object.keys(this.state.filterBy).length > 0) {
				users = this.filterFunc(users, this.state.filterBy)
			}

			//Sorting filtered User List
			if (this.state.sortBy !== '') {
				users.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
			}

			var userList = []
			for (user of users) {
				if (user.email === 'dirad') {
					//Do nothing. Hide the default dirad user account.
				} else {
					userList.push(
						<div className="dataRow" key={user.email}>
							<span style={{ flex: '0 0 300px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }} onClick={this.edit(user)} className="userID">{user.email}</span>
							<span style={{ flex: '1 0 20%' }} onClick={this.edit(user)} className="userName">{user.firstName + ' ' + user.lastName}</span>
							<span style={{ flex: '1 1 30%' }} onClick={this.changeStatus(user)}>
								{user.loggedIn ? <span>{user.status}</span> : ''}
								{user.loggedIn ? <span style={{ float: 'right' }}>{this.convertMS(this.state.time - new Date(user.ActivityDateTime))}</span> : ''}
							</span>
							<span className="buttonBox" style={{ flex: '0 0 250px' }}>
								{this.props.data.Roles ?
									<img src={this.props.img.role} alt="Change Roles" onClick={this.changeRoles(user)} />
									:
									''
								}

								{user.failedAttempts > 3 ?
									<img src={this.props.img.redLock} alt="Unlock" onClick={this.unlockUser(user)} />
									:
									<img src={this.props.img.unlock} alt="Reset" onClick={this.resetUser(user)} />
								}
								{this.props.features.callCenter ?
									<img src={this.props.img.group} alt="Change Workgroups" onClick={this.changeWorkgroups(user)} />
									:
									''
								}
								<img src={this.props.img.delete} alt="Delete User" onClick={this.deleteUser(user)} />
							</span>
						</div>
					)
				}
			}

			var editUser = ""
			if (this.state.editing) {
				editUser = (
					<div className="blackout">
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>

							<div className="snazzyInputBox">
								<input className="textInput" type="text" required value={this.state.editing.email} onChange={this.valueChange('email')} ></input>
								<span className="inputBar"></span><label className="textLabel">Email Address</label>
							</div>

							{!this.state.editing.id ? <div className="snazzyInputBox">
								<input className="textInput" type="password" required value={this.state.editing.password} onChange={this.valueChange('password')} ></input>
								<span className="inputBar"></span><label className="textLabel">Password</label>
							</div> : ''}

							<div className="snazzyInputBox">
								<input className="textInput" type="text" required value={this.state.editing.firstName} onChange={this.valueChange('firstName')} ></input>
								<span className="inputBar"></span><label className="textLabel">First Name</label>
							</div>

							<div className="snazzyInputBox">
								<input className="textInput" type="text" required value={this.state.editing.lastName} onChange={this.valueChange('lastName')} ></input>
								<span className="inputBar"></span><label className="textLabel">Last Name</label>
							</div>

							{this.props.features.tui ? <div className="snazzyInputBox">
								<input className="textInput" type="text" required value={this.state.editing.userID} onChange={this.valueChange('userID')} ></input>
								<span className="inputBar"></span><label className="textLabel">User ID (Optional)</label>
							</div> : ''}

							{this.props.features.tui ? <div className="snazzyInputBox">
								<input className="textInput" type="password" required value={this.state.editing.accessCode} onChange={this.valueChange('accessCode')} ></input>
								<span className="inputBar"></span><label className="textLabel">Access Code (Optional)</label>
							</div> : ''}

							<div className="error">{this.state.error}</div>

							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirm}>
								{this.state.editing.id ? "Confirm Changes" : "Create New User"}
							</div>}
						</div>
					</div>
				)
			}

			var delUser = ""
			if (this.state.deleting) {
				delUser = (
					<div className="blackout">
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>
							<div>You Are Removing User</div>
							<div style={{ margin: "15px" }}> {this.state.deleting.wholeName} </div>
							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmDeleteUser}>Delete This User</div>}
						</div>
					</div>
				)
			}

			var editRoles = ""
			if (this.state.editingRoles) {
				var roles = this.props.data.Roles
				var roleList = []
				var removeRoleList = []
				var selRoleList = []
				var addRoleList = []

				for (var role in roles) {
					if (this.state.editingRoles.roles[role] === true && this.state.rolesToRemove.indexOf(role) < 0) {
						selRoleList.push(
							<div key={role} className="dataRow" onClick={this.removeRole(role)}>{role}</div>
						)
					} else if (this.state.rolesToAdd.indexOf(role) > -1) {
						addRoleList.push(
							<div key={role} data-role={role} style={{ fontStyle: 'italic' }} className="dataRow" onClick={this.removeRole(role)}>{role}</div>
						)
					} else if (this.state.rolesToRemove.indexOf(role) > -1) {
						removeRoleList.push(
							<div key={role} data-role={role} style={{ fontStyle: 'italic' }} className="dataRow" onClick={this.addRole(role)}>{role}</div>
						)
					} else {
						roleList.push(
							<div key={role} data-role={role} className="dataRow" onClick={this.addRole(role)}>{role}</div>
						)
					}
				}
				editRoles = (
					<div className="blackout">
						<div className="pop" style={{ width: "80vw", maxWidth: "1000px" }}>
							<div className="viewCloser" onClick={this.cancel}></div>
							<div style={{ marginBottom: "25px" }}>Edit Roles for {this.state.editingRoles.wholeName}</div>
							<div style={{ display: "inline-block" }}>
								<div className="loginLabel" >Available Roles</div>
								<div id="availableRoles" className="roleBox">
									{removeRoleList}
									{roleList}
								</div>
							</div>
							<div style={{ display: "inline-block" }}>
								<div className="loginLabel" >Selected Roles</div>
								<div id="selectedRoles" className="roleBox">
									{addRoleList}
									{selRoleList}
								</div>
							</div>
							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmRoleChanges}>Confirm Roles</div>}
						</div>
					</div>
				)
			}

			var resetUser = ""
			if (this.state.resetting) {
				resetUser = (
					<div className="blackout">
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>
							<div className="loginLabel">Reset the Password for {this.state.resetting.wholeName}</div>

							<div className="snazzyInputBox">
								<input className="textInput" type="text" required value={this.state.resetUserPIN} onChange={this.resetUserPINChange} ></input>
								<span className="inputBar"></span><label className="textLabel">Enter a New Password</label>
							</div>
							<div className="error">{this.state.error}</div>
							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmResetUser}>Reset Password</div>}
						</div>
					</div>
				)
			}
			var unlockUser = ""
			if (this.state.unlocking) {
				unlockUser = (
					<div className="blackout">
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>
							<div className="loginLabel" style={{ marginBottom: '15px' }}>Unlock Account for {this.state.unlocking.wholeName}</div>
							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmUnlockUser}>Unlock Account</div>}
						</div>
					</div>
				)
			}
			var changeStatus = ""
			if (this.state.changingStatus) {
				var statusList = (
					<div id="statusList">
						<h3 onClick={this.confirmUserLogout} id="logOut" >- Log Out -</h3>
					</div>
				)

				changeStatus = (
					<div className="blackout">
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>
							<div className="loginLabel" style={{ marginBottom: '15px' }}>Change Status for {this.state.statusUserName}</div>
							{statusList}
							{this.state.loading ? <div className="loader"></div> : ''}
						</div>
					</div>
				)
			}

			return (
				<div className="viewContent">
					<img src={this.props.img.plus} className="plusButton" alt="Add a User" onClick={this.add} />

					<div className="dataHeaders">
						<span style={{ flex: '0 0 300px', cursor: 'pointer' }} onClick={this.sort("email")}>Email</span>
						<span style={{ flex: '1 0 20%', cursor: 'pointer' }} onClick={this.sort("wholeName")}>Name</span>
						<span style={{ flex: '1 1 15%', cursor: 'pointer' }} onClick={this.sort("status")}>Status</span>
						<span style={{ flex: '1 1 15%', cursor: 'pointer' }} onClick={this.sort("ActivityDateTime")}>Time</span>
						<span style={{ flex: '0 0 280px' }} ></span>
					</div>
					<div className="dataFilters">
						<input style={{ flex: '0 0 310px' }} type="text" onChange={this.filter("email")} value={this.state.filterBy.email} ref="email" data-filterBy="email" />
						<input style={{ flex: '1 0 20%' }} type="text" onChange={this.filter("wholeName")} value={this.state.filterBy.wholeName} ref="wholeName" data-filterBy="wholeName" />
						<input style={{ flex: '1 1 30%' }} type="text" onChange={this.filter("status")} value={this.state.filterBy.status} ref="Status" data-filterBy="status" />
						<span style={{ flex: '0 0 280px' }} ></span>
					</div>

					<div style={{ overflow: 'auto', height: 'calc(100% - 85px)' }}>
						{userList}
					</div>

					{editUser}
					{unlockUser}
					{resetUser}
					{delUser}
					{editRoles}
					{changeStatus}
				</div>
			);
		} else {
			return (
				<div></div>
			);
		}
	}
}

export { Users, icon, roles }